const deviceFields = {
    depth: "",
    shape: "",
    width: "",
    length: "",
    latitude: "",
    longitude: "",
}

function deepCopy(value) {
    return JSON.parse(JSON.stringify(value))
}

function capitalizeWords(str) {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
}

const getKeyWithSpecialValue = (obj, specialValue) => {
    const entry = Object.entries(obj).find(
        ([key, value]) => value === specialValue
    );
    return entry ? entry[0] : undefined;
};

function formatNumber(input) {
    return parseInt(input);
}

const formatColumnName = (name) => {
    return name
        .replace(/_/g, " ") // Replace underscores with spaces
        .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize first letter of each word
};

const cond = [null, undefined];

const calculateFullDate = (estimatedDays) => {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + estimatedDays);

    const day = String(currentDate.getDate()).padStart(2, "0"); // Ensure 2-digit day
    const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const year = currentDate.getFullYear();

    return `${month}/${day}/${year}`;
};

const formatValue = (value, format, display_ui) => {
    let ans = value;
    if (typeof value === 'boolean') {
        ans = value ? 'True' : 'False'
    }

    return ans + format
}

export { 
    deviceFields, 
    deepCopy,
    capitalizeWords,
    getKeyWithSpecialValue,
    formatNumber,
    formatColumnName,
    cond,
    calculateFullDate,
    formatValue
};